import React from 'react'
import TransactionApprovalButton from '../approval-button'

export const ButtonWrapper: React.FC = () => {
  return <TransactionApprovalButton />
}
export default ButtonWrapper
